export const DELETE_MULTIPLE_INVALID_OPTIONS = "DELETE_MULTIPLE_INVALID_OPTIONS";

export default function deleteMultipleInvalidOptions(questionId, repeatId, options) {
  return {
    type: DELETE_MULTIPLE_INVALID_OPTIONS,
    payload: { questionId, repeatId, options },
  };
}
